export var EPenaltyAmountType;
(function (EPenaltyAmountType) {
    EPenaltyAmountType["Percentage"] = "PERCENTAGE";
    EPenaltyAmountType["Fixed"] = "FIXED";
})(EPenaltyAmountType || (EPenaltyAmountType = {}));
